export class FgStockTransferLocationDto{
    locationId:number;
    cartons:string;
    soNumber:number;   
}